import { Field, Select } from './Field.tsx';

type CompanyOption = { id: string; company_name: string };

/**
 * Owner selector for create modals. `value === ''` means the Operating company
 * (admin-owned, company_id null); any other value is a contractor company id.
 */
export function OwnerPicker({
  value,
  onChange,
  companies,
  label = 'Owner',
}: {
  value: string;
  onChange: (companyId: string) => void;
  companies: CompanyOption[];
  label?: string;
}) {
  return (
    <Field label={label} required>
      <Select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Operating company</option>
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.company_name}
          </option>
        ))}
      </Select>
    </Field>
  );
}
